export default "__VITE_ASSET__NWLzhPiPaBaaiAfCGcnXqQ__"